import { httpDelete, httpGet, httpPut } from "shared/api/apiHandler";
import urls from "shared/api/notificationService/urls";
import BooleanResponseWithErrors from "shared/models/booleanResponseWithErrors";
import { UserNotification } from "shared/interfaces/notifications";
import { ID } from "shared/interfaces/common";

export const getUserNotifications = async (): Promise<Array<UserNotification>> => {
    const result = await httpGet<Array<UserNotification>>(
        window.APP_SETTINGS.notificationServiceApiBaseUri,
        urls.NOTIFICATIONS.ROOT
    );
    return result.data;
};

export const getNotReadNotificationsCount = async (): Promise<number> => {
    const result = await httpGet<number>(
        window.APP_SETTINGS.notificationServiceApiBaseUri,
        urls.NOTIFICATIONS.NOT_READ_COUNT,
        { hideToastOnNoInternetConnection: true }
    );
    return result.data;
};

export const deleteUserNotification = async (id: ID): Promise<BooleanResponseWithErrors> => {
    const result = await httpDelete<BooleanResponseWithErrors>(
        window.APP_SETTINGS.notificationServiceApiBaseUri,
        urls.NOTIFICATIONS.DELETE_NOTIFICATION(id)
    );
    return result.data;
};

export const markAllUserNotificationsAsRead = async (): Promise<BooleanResponseWithErrors> => {
    const result = await httpPut<BooleanResponseWithErrors>(
        window.APP_SETTINGS.notificationServiceApiBaseUri,
        urls.NOTIFICATIONS.MARK_AS_READ,
        {}
    );
    return result.data;
};

export const deleteAllUserNotifications = async (): Promise<BooleanResponseWithErrors> => {
    const result = await httpDelete<BooleanResponseWithErrors>(
        window.APP_SETTINGS.notificationServiceApiBaseUri,
        urls.NOTIFICATIONS.DELETE_ALL_NOTIFICATION
    );
    return result.data;
};
